
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 72 72"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M64.3 31.32H7.7c-.99 0-1.78.8-1.78 1.78v9.99c0 .99.8 1.78 1.78 1.78h56.6c.99 0 1.78-.8 1.78-1.78V33.1c0-.99-.8-1.78-1.78-1.78zm0 17.01H7.7c-.99 0-1.78.8-1.78 1.78v9.99c0 .99.8 1.78 1.78 1.78h56.6c.99 0 1.78-.8 1.78-1.78v-9.99c0-.98-.8-1.78-1.78-1.78zm0 17.01H7.7c-.99 0-1.78.8-1.78 1.78V72h60.16v-4.87c0-.99-.8-1.79-1.78-1.79zM36 29.01l9.98-9.98h-6.34V6.41h-7.28v12.62h-6.34z"}})])
          )
        }
      }
    